import { MainNavScreens } from "breadcommon";
import { createContext } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { mainNavScreenForSlug } from "./main_nav/mainNavDefinitions";

type UrlInfo = {
  currentTab: MainNavScreens | null;
};

export const UrlContext = createContext<UrlInfo>({
  currentTab: null,
});

export function UrlContextProvider(props: {
  children: JSX.Element;
}): JSX.Element {
  const location = useLocation();
  // Nav tabs live at the root of the URL namespace, which they share with the
  // marketing pages routed in Router.tsx. A new tab whose slug matches a
  // marketing path (e.g. a "pricing" tab vs. a /pricing page) would shadow it,
  // so check Router.tsx before adding a slug to mainNavDefinitions.
  // Each screen owns the remaining path (for example, its selected sub-tab).
  const urlMatch = matchPath(
    { path: "/:currentTab", end: false },
    location.pathname,
  );
  const currentTabSlug = urlMatch?.params.currentTab;
  const currentTab = currentTabSlug
    ? mainNavScreenForSlug(currentTabSlug)
    : null;

  return (
    <UrlContext.Provider value={{ currentTab }}>
      {props.children}
    </UrlContext.Provider>
  );
}
